import React from 'react'
import ReactDOM from 'react-dom/client'

import App from './App'
import reportWebVitals from './reportWebVitals'

import { AppContextProvider } from './context/AppContext'
import { CheckoutFormContextProvider } from './context/CheckoutFormContext'

import './App.scss'

const composeProviders =
    (...Providers) =>
    (Child) =>
    (props) =>
        Providers.reduce(
            (acc, Provider) => <Provider>{acc}</Provider>,
            <Child {...props} />
        )

const WrappedApp = composeProviders(
    AppContextProvider,
    CheckoutFormContextProvider
)(App)
const root = ReactDOM.createRoot(document.getElementById('root'))
root.render(
    // <React.StrictMode>
    <WrappedApp />
    // </React.StrictMode>
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
